module.exports = __webpack_public_path__ + "img/block-g-1-m.22cae8d3.jpg";